import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createActionCreator, createBoundActionCreator, createType } from '../../shared/state/index.state';

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class GatewayActions {
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //              ACTION CREATORS
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    static GET_SHARED_NUMBERS = createActionCreator<number>(createType('[Admin:SharedNumbers] Get Shared Numbers'));
    static GET_SHARED_NUMBERS_SUCCESS = createActionCreator<Array<string>>(createType('[Admin:SharedNumber] Gets Shared Numbers Success'));
    static GET_SHARED_NUMBERS_FAIL = createActionCreator<any>(createType('[Admin:SharedNumber] Gets Shared Numbers Failed'));

    constructor(private store: Store<any>) {}

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //              BOUND ACTIONS
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    getSharedNumbers = createBoundActionCreator(GatewayActions.GET_SHARED_NUMBERS, this.store.dispatch.bind(this.store));
}
